import * as React from 'react';

interface IProps {
    label: string;
    id: string;
    trueLabel: string;
    falseLabel: string;
    value?: boolean;
    onChange: (event: any) => void;
}

export class RadioInput extends React.Component<IProps> {
    
    public render(): React.ReactNode {
        const trueValueId: string = this.props.id + this.props.trueLabel;
        const falseValueId: string = this.props.id + this.props.falseLabel;

        return (
            <div className="radio-input-group" id={this.props.id}>
                <fieldset>
                    <legend>{this.props.label}</legend>
                    <div className="custom-radio">
                        <input
                            id={trueValueId}
                            name={trueValueId}
                            type="radio"
                            value="true"
                            checked={this.props.value === true}
                            onChange={this.props.onChange}
                        />
                        <label 
                            id={trueValueId + "-label"} 
                            htmlFor={trueValueId}
                        >
                            {this.props.trueLabel}
                        </label>
                    </div>
                    <div className="custom-radio">
                        <input
                            id={falseValueId}
                            name={falseValueId}
                            type="radio"
                            value="false"
                            checked={this.props.value === false}
                            onChange={this.props.onChange}
                        />
                        <label 
                            id={falseValueId + "-label"} 
                            htmlFor={falseValueId}
                        >
                            {this.props.falseLabel}
                        </label>
                    </div>
                </fieldset>
            </div>
        )
    }
}
